import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Notfound from "../Notfound";
import Xenplatform from "./Xenplatform/Index";
import { AppBar, Avatar, Box, Toolbar, Typography } from "@mui/material";
import Xendit from "./Xendit/Index";


const CheckoutInvoice = () => {
    const location = useLocation();
    const user_id = new URLSearchParams(location.search).get('user_id');
    const invoice_id = new URLSearchParams(location.search).get('invoice_id');
    const channel = new URLSearchParams(location.search).get('channel');
    const paymentChannel = new URLSearchParams(location.search).get('payment_channel');
    const [views, setViews] = useState("")
   
    const getViewChannel = (paymentChannel) => {
        switch(paymentChannel) {
            case 'xenplatform' :
                setViews(<Xenplatform user_id={user_id} invoice_id={invoice_id} channel={channel}/>)
                break;
            case 'xendit' :
                setViews(<Xendit user_id={user_id} invoice_id={invoice_id} channel={channel}/>)
                break;
            default :
                setViews(<Notfound />)
                break;
        }
    }

    useEffect(() => {
        const init = () => {
            getViewChannel(paymentChannel)
        };
        init();
    }, [user_id, invoice_id, channel, paymentChannel])

    return(
        <>
            <Box className="noPrint" marginTop={2}>
                <AppBar position="fixed" sx={{bgcolor: "#1f283e"}}>
                    <Toolbar>
                        <Avatar alt="Remy Sharp" src={process.env.PUBLIC_URL + '/radboox-icon.png'} />
                        <Typography
                            variant="h6"
                            noWrap
                            component="a"
                            href="https://www.radboox.com"
                            sx={{
                                mx: 2,
                                fontSize: "26px",
                                fontFamily: 'Roboto',
                                fontWeight: 700,
                                color: 'inherit',
                                textDecoration: 'none',
                            }}
                        >
                            RadbooX
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Toolbar />
            </Box>
            {views}
        </>
        
    )
}

export default CheckoutInvoice;